import React from 'react'

export default function Pharmacies() {
    return (
        <div style={{ margin: 'auto', textAlign: 'center', width: '100%', maxWidth: '400px' }}>
            <a href="https://www.eczaneler.gen.tr/nobetci-hatay-iskenderun" target="_blank" rel="noopener noreferrer">
                <img 
                    src="https://www.eczaneler.gen.tr/resimler/nobetci-eczane.jpg" 
                    alt="İskenderun nöbetçi eczaneleri" 
                    style={{ width: '100%', borderRadius: '2px' }}
                />
            </a>
            <iframe 
                src="https://www.eczaneler.gen.tr/iframe.php?lokasyon=1413" 
                name="İskenderun nöbetçi eczaneleri" 
                style={{ width: '100%', height: '400px', border: 'none' }}
                title="İskenderun nöbetçi eczaneleri"
            />
        </div>
    )
}
